import { useCallback } from "react"

export const useMapRoutePatterToRegex = () => {
    return useCallback((url: string) => {
        let newUrl = url.replace(/(:[\w]+)/g, '(?!\/).*') 
        if (!/^\//.test(newUrl)) {
            newUrl = `^\/${newUrl}`
        }

        if (!/^\^/.test(newUrl)) {
            newUrl = `^${newUrl}`
        }

        return new RegExp(newUrl, 'g')
    }, [])
}
